

export function buttonbaby_click(event) {

$w ('#box3') .show ();

$w ('#box4') .hide ();

$w ('#box5') .hide ();

$w ('#box6') .hide ();
$w ('#box7') .hide ();
$w ('#box8') .hide ();
$w ('#box99') .hide ();

}

export function buttontoddler_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .show ();

$w ('#box5') .hide ();

$w ('#box6') .hide ();
$w ('#box7') .hide ();
$w ('#box8') .hide ();
$w ('#box99') .hide ();

}

export function buttonad_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .hide ();

$w ('#box5') .show ();

$w ('#box6') .hide ();
$w ('#box7') .hide ();
$w ('#box8') .hide ();
$w ('#box99') .hide ();

}


export function buttonpre_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .hide ();

$w ('#box5') .hide ();

$w ('#box6') .show ();
$w ('#box7') .hide ();
$w ('#box8') .hide ();
$w ('#box99') .hide ();

}


export function buttonart_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .hide ();

$w ('#box5') .hide ();

$w ('#box6') .hide ();
$w ('#box7') .show ();
$w ('#box8') .hide ();
$w ('#box99') .hide ();

}


export function buttonplay_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .hide ();

$w ('#box5') .hide ();

$w ('#box6') .hide ();
$w ('#box7') .hide ();
$w ('#box8') .show ();
$w ('#box99') .hide ();

}


export function buttonwood_click(event) {

$w ('#box3') .hide ();

$w ('#box4') .hide ();

$w ('#box5') .hide ();

$w ('#box6') .hide ();
$w ('#box7') .hide ();
$w ('#box8') .hide ();
$w ('#box99') .show ();

}